import { Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import Skeleton from "./Skeleton";
import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getAdById,
  getNativeAnalytic,
  totalClicksByAdId,
  totalImpressionByAdId,
} from "../../db";
import LineChart from "./LineChart";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: 10,
    padding: 20,
  },
  image: {
    margin: "10px 0",
    maxWidth: 200,
    borderRadius: 5,
    boxShadow: "2px 2px 5px 1px",
  },
  grid: {
    margin: "5px 0",
  },
}));

const Single = () => {
  const params = useParams();
  const classes = useStyles();
  const ad_id = params.id;

  const [nativeAnalytic, setNativeAnalytic] = useState([]);
  const [interstitialAnalytic, setInterstitialAnalytic] = useState([]);
  const [ad, setAd] = useState({});
  const [loading, setLoading] = useState(false);
  const [totalCounts, setTotalCounts] = useState({
    impressions: 0,
    hits: 0,
  });
  useEffect(() => {
    getData();
    getTotalCounts();
  }, []);

  const getData = async () => {
    setLoading(true);
    const native = await getNativeAnalytic(ad_id, "native");
    const interstitial = await getNativeAnalytic(ad_id, "interstitial");
    const ad = await getAdById(ad_id);
    setAd(ad.data());
    setNativeAnalytic(native);
    setInterstitialAnalytic(interstitial);
    setLoading(false);
  };

  const getTotalCounts = async () => {
    const impressions = await totalImpressionByAdId(ad_id);
    const hits = await totalClicksByAdId(ad_id);
    setTotalCounts({ impressions, hits });
  };

  return (
    <Fragment>
      {loading ? (
        <Skeleton />
      ) : (
        <Fragment>
          <Grid container alignItems="center">
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant="h6" className={classes.heading}>
                Campaign Name
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                style={{ paddingRight: 20 }}
              >
                {ad.title}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant="h6" className={classes.heading}>
                Website
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                style={{ paddingRight: 20 }}
              >
                {ad.website}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.grid}>
              <Typography variant="h6" className={classes.heading}>
                Description
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                style={{ paddingRight: 20 }}
              >
                {ad.description}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant="h6" className={classes.heading}>
                Native Image
              </Typography>
              {ad.hasNative ? (
                <img src={ad.native} alt="native" className={classes.image} />
              ) : (
                "No Image Found!"
              )}
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant="h6" className={classes.heading}>
                Interstitial Image
              </Typography>
              {ad.hasNative ? (
                <img
                  src={ad.interstitial}
                  alt="interstitial"
                  className={classes.image}
                />
              ) : (
                "No Image Found!"
              )}
            </Grid>

            <Grid item md={12} xl={6} className={classes.heading}>
              <Typography variant="h6">
                Total Clicks: {totalCounts.hits}
              </Typography>
            </Grid>
            <Grid item md={12} xl={6} className={classes.heading}>
              <Typography variant="h6">
                Total Impression: {totalCounts.impressions}
              </Typography>
            </Grid>

            <Grid item xs={12} style={{ margin: "20px 0" }}>
              <Divider variant="fullWidth" />
            </Grid>

            <Grid item xs={12} style={{ textAlign: "right" }}>
              <Typography variant="caption">
                Created on {dayjs(ad.createdAt).format("DD MMM, YYYY")}
              </Typography>
            </Grid>

            <Grid item md={12} xl={6}>
              <LineChart data={nativeAnalytic} title="Native" />
            </Grid>
            <Grid item md={12} xl={6}>
              <LineChart data={interstitialAnalytic} title="Interstitial" />
            </Grid>
          </Grid>
        </Fragment>
      )}
    </Fragment>
  );
};

export default React.memo(Single);
